module.exports = __webpack_public_path__ + "img/shipboardTraining.83a5ad09.jpg";